/**
 * 
 * @param {string} name Adds the name to the table header to dynamically generate appropriate columns
 * @returns {{label: string, key: string}[]} Array of label, key objects to pull out row values and place them in the correct column.
 */
export const scopeOneEmissionColumns = (name) => [
    { label: 'Scope 1: Direct GHG Emissions', key: 'category' },
    { label: name, key: 'value' },
    { label: 'Unit', key: 'unit' },
    { label: '%', key: 'percent' },
]

/**
 * 
 * @param {string} name Adds the name to the table header to dynamically generate appropriate columns
 * @returns {{label: string, key: string}[]} Array of label, key objects to pull out row values and place them in the correct column.
 */
export const scopeTwoEmissionColumns = (name) => [
    { label: 'Scope 2: Electricity Indirect GHG Emissions', key: 'category' },
    { label: name, key: 'value' },
    { label: 'Unit', key: 'unit' },
    { label: '%', key: 'percent' },
]

/**
 * 
 * @param {string} name Adds the name to the table header to dynamically generate appropriate columns
 * @returns {{label: string, key: string}[]} Array of label, key objects to pull out row values and place them in the correct column.
 */
export const scopeThreeEmissionColumns = (name) => [
    { label: 'Scope 3: Other Indirect GHG Emissions', key: 'category' },
    { label: name, key: 'value' },
    { label: 'Unit', key: 'unit' },
    { label: '%', key: 'percent' },
]

/**
 * Overview type used in CFDashboard.js
 */
export const overviewTypes = ['Consumption', 'Emissions']
/**
 * Gap Between the top-level accordions under the overview types
 */
export const subAccordionGap = 2
/**
 * Width of the emissions table. Used to keep the excel button tied to the rightmost edge of the emissions table
 * and to normalize styling
 */
export const emissionsTableWidth = '70%'
export const scopeOneTitle = 'Scope 1 - Direct Emissions from Owned or Controlled Sources'
export const scopeTwoTitle = 'Scope 2 - Indirect Emissions from the Generation of Purchased Energy'
export const scopeThreeTitle = 'Scope 3 - Indirect Emissions (Not Included in Scope 2) that Occur in the Value Chain of the Reporting Company'

export const summaryColumns = [
    { label: 'Corporate GHG Emissions', key: 'category' },
    { label: 'Value', key: 'value' },
    { label: 'Unit', key: 'unit' },
    { label: '%', key: 'percent' },
]